// http://localhost:8000/users/validate-token
import config from "../config";

const validateToken = async (token) => {
  try {
    const response = await fetch(`${config.backendUrl}/users/validate-token`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error validating token:", error);
    return { message: "Token validation failed", error: error.message };
  }
};

export default validateToken;